<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('remplacementFace.title', { code: infoFace.code}) }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <a @click="$router.go(-1)"
                 class="button">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns mgt-10px">
      <form @submit.prevent="recherche()"
            class="column is-3 pdr-0">
        <b-input :placeholder="$t('general.button.search')"
                 type="search"
                 v-model="criteresRecherche.auto"
                 icon="magnify">
        </b-input>
      </form>
      <div class="column is-narrow">
        <button class="button" @click='showFiltre = !showFiltre'>
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">{{$t('general.button.filtre')}}</span>
        </button>
        <div class="info-circle-right background-primary is-pulled-right"
             v-if="nombreCritere > 0">
          <span class="inside-circle">{{ nombreCritere }}</span>
        </div>
      </div>
    </div>
    <v-server-table url=""
                    v-if="startArrayRendering"
                    :columns="columns"
                    :options="options"
                    @loaded="finLoading"
                    @loading="debutLoading"
                    ref="tableListeProduitsFace">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableListeProduitsFace.setLimit($event)"/>
      </template>
      <div slot="remplacer" slot-scope="props">
        <a class="button is-primary is-fullwidth" @click="openPopUpPrevention(props.row)">
          <span>{{ $t('remplacementFace.actions.remplacer') }}</span>
        </a>
      </div>
      <div slot="reference" slot-scope="props">
        <router-link-blank
          :to="{ name: 'c.bodac.catalogue-face',
        params: { id: props.row.id, isFromListeProduitFace: false }}"
          :message="props.row.reference"/>
      </div>
      <div slot="adresse" slot-scope="props">
        <div>{{ props.row.produitFace.adresse | adresse }}</div>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-if="showFiltre === true">
        <filtre-remplacement-face :critere-recherche-from-page="criteresRecherche"
                                  @toggleFiltre="showFiltre = !showFiltre"
                                  @updateCritereAndSearch="updateCritereAndSearch"
        />
      </div>
    </transition>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="textPrevention"
        :isErrorPopup.sync='error'
        :messagesPopup='messages'
        :cancel="$t('general.button.return')"
        :validate="$t('general.button.valider')"
        @no="closePopUpPrevention"
        @yes="remplaceProduit">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import {
  genererCritereRechercheProduitFaceRemplacement,
} from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitFace';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import TableItemsInView from '@/components/general/TableItemsInView';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import filtreRemplacementFace from '@/components/gabed/face/filtreRemplacementFace';
import popUpPrevention from '@/components/general/popUpPrevention';
import { updateProduitFace } from '@/api/gabed/face';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import validationUpdateFace from '@/services/gabed/face/validationDeleteFace';
import validationGeneral from '@/services/validation/validation';

const ProduitFace = createNamespacedHelpers('produitFace');
const Face = createNamespacedHelpers('face');

export default {
  data() {
    return {
      criteresRecherche: genererCritereRechercheProduitFaceRemplacement(),
      showFiltre: false,
      startArrayRendering: false,
      popUpPrevention: false,
      produitIdForRemplacement: null,
      textPrevention: null,
      messages: [],
      error: false,
    };
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
  components: {
    breadcrumb,
    TableItemsInView,
    routerLinkBlank,
    filtreRemplacementFace,
    popUpPrevention,
  },
  computed: {
    ...ProduitFace.mapGetters({
      produitsFace: 'produits',
      totalCount: 'totalProduits',
    }),
    ...Face.mapGetters({
      infoFace: 'infoFace',
      breadcrumb: 'breadcrumb',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.title'), route: { name: 'l.gabed.emplacement' }, isActive: false },
        { title: this.$i18n.t('detailEmplacement.titleWithoutN'), route: '', isActive: false },
        { title: this.$i18n.t('remplacementFace.breadcrumb.remplacer'), router: '', isActive: true },
      ];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$i18n.t('remplacementFace.tabs.reference'),
          libelle: this.$i18n.t('remplacementFace.tabs.libelle'),
          adresse: this.$i18n.t('remplacementFace.tabs.adresse'),
          'produitFace.adresse.ville': this.$i18n.t('remplacementFace.tabs.ville'),
          'produitFace.adresse.codePostal': this.$i18n.t('remplacementFace.tabs.codePostal'),
          'produitFace.adresse.departement': this.$i18n.t('remplacementFace.tabs.departement'),
          'produitFace.adresse.agglomeration': this.$i18n.t('remplacementFace.tabs.agglomeration'),
          'produitFace.format': this.$i18n.t('remplacementFace.tabs.format'),
          'produitFace.materielType': this.$i18n.t('remplacementFace.tabs.materiel'),
          'produitFace.support': this.$i18n.t('remplacementFace.tabs.support'),
          remplacer: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: ['reference', 'libelle', 'produitFace.format', 'produitFace.adresse.ville', 'produitFace.adresse.codePostal', 'produitFace.adresse.departement', 'produitFace.adresse.agglomeration', 'produitFace.materielType', 'produitFace.support'],
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.infoFace.societeId;
          data.query.agencesId = [this.infoFace.agenceId];
          data.query.sansFaceId = true;
          data.query.actif = true;
          return this.loadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produitsFace,
            count: this.totalCount,
          };
        }),
      };
    },
    nombreCritere() {
      const nbCritere = calculNombreCritere(this.criteresRecherche, ['auto']);
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columns() {
      return ['reference', 'libelle', 'adresse', 'produitFace.adresse.codePostal', 'produitFace.adresse.ville', 'produitFace.adresse.departement', 'produitFace.adresse.agglomeration', 'produitFace.format', 'produitFace.materielType', 'produitFace.support', 'remplacer'];
    },
  },
  methods: {
    ...ProduitFace.mapActions({
      loadProduits: 'loadProduitsWithoutDispo',
    }),
    ...Face.mapActions({
      setInfoFace: 'setInfoFace',
    }),
    openPopUpPrevention(produit) {
      this.produitIdForRemplacement = produit.id;
      this.textPrevention = this.$i18n.t('remplacementFace.popUpRemplacement.title', {
        codeProduit: produit.reference,
        codeFace: this.infoFace.code,
      });
      this.popUpPrevention = true;
    },
    closePopUpPrevention() {
      this.error = false;
      this.messages = [];
      this.textPrevention = null;
      this.produitIdForRemplacement = null;
      this.popUpPrevention = false;
    },
    async remplaceProduit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        await updateProduitFace({
          faceId: this.infoFace.id,
          produitId: this.produitIdForRemplacement,
        });
        messageSucces(this.$i18n.t('remplacementFace.succes.replace'));
        this.closePopUpPrevention();
        this.$router.go(-1);
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          validationUpdateFace(e.response, this.messages);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    recherche() {
      this.$refs.tableListeProduitsFace.refresh();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    updateCritereAndSearch(newCritere) {
      this.criteresRecherche = cloneDeep(newCritere);
      this.showFiltre = false;
      this.recherche();
    },
  },
  beforeDestroy() {
    this.setInfoFace(null);
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    if (!this.infoFace) {
      loadingComponent.close();
      this.$router.go(-1);
      return;
    }
    this.startArrayRendering = true;
    this.setInformationPage(this.$t('pagePatrimoine.emplacement.remplacementFace'));
    loadingComponent.close();
  },
};

</script>
